export default function (state, getters, rootState, rootGetters) {
    return rootState.subsidies.settings;
}
